export { default as Svg12Add } from '../Icons/12Add'
export { default as Svg12ArrowBack } from '../Icons/12ArrowBack'
export { default as Svg12ArrowDown } from '../Icons/12ArrowDown'
export { default as Svg12ArrowForward } from '../Icons/12ArrowForward'
export { default as Svg12ArrowUp } from '../Icons/12ArrowUp'
export { default as Svg12AppStore } from '../Icons/12AppStore'
export { default as Svg12Bookmark } from '../Icons/12Bookmark'
export { default as Svg12CaretBack } from '../Icons/12CaretBack'
export { default as Svg12CaretDown } from '../Icons/12CaretDown'
export { default as Svg12CaretForward } from '../Icons/12CaretForward'
export { default as Svg12CaretUp } from '../Icons/12CaretUp'
export { default as Svg12Check } from '../Icons/12Check'
export { default as Svg12Clock } from '../Icons/12Clock'
export { default as Svg12DotActive } from '../Icons/12DotActive'
export { default as Svg12DotInactive } from '../Icons/12DotInactive'
export { default as Svg12Edit } from '../Icons/12Edit'
export { default as Svg12Filters } from '../Icons/12Filters'
export { default as Svg12InfoCircle } from '../Icons/12InfoCircle'
export { default as Svg12Location } from '../Icons/12Location'
export { default as Svg12Minus } from '../Icons/12Minus'
export { default as Svg12Night } from '../Icons/12Night'
export { default as Svg12Notification } from '../Icons/12Notification'
export { default as Svg12PlayStore } from '../Icons/12PlayStore'
export { default as Svg12Search } from '../Icons/12Search'
export { default as Svg12SearchIcon } from '../Icons/12SearchIcon'
export { default as Svg12Share } from '../Icons/12Share'
export { default as Svg12StarFilled } from '../Icons/12StarFilled'
export { default as Svg12Trash } from '../Icons/12Trash'
export { default as Svg12StarHalf } from '../Icons/12StarHalf'
export { default as Svg12StarOutlined } from '../Icons/12StarOutlined'
export { default as Svg12Trending } from '../Icons/12Trending'
export { default as Svg12Tryon } from '../Icons/12Tryon'
export { default as Svg12Video } from '../Icons/12Video'
export { default as Svg12VideoFilled } from '../Icons/12VideoFilled'
export { default as Svg12Wallet } from '../Icons/12Wallet'
export { default as Svg12X } from '../Icons/12X'
export { default as Svg12ConsciousBeauty } from '../Icons/12ConsciousBeauty'
export { default as Svg12Vegan } from '../Icons/12Vegan'
export { default as Svg12Clean } from '../Icons/12Clean'
export { default as Svg12PositiveImpact } from '../Icons/12PositiveImpact'
export { default as Svg12SustainablePackaging } from '../Icons/12SustainablePackaging'
export { default as Svg12CrueltyFree } from '../Icons/12CrueltyFree'
export { default as Svg16ConsciousBeauty } from '../Icons/16ConsciousBeauty'
export { default as Svg16Vegan } from '../Icons/16Vegan'
export { default as Svg16Clean } from '../Icons/16Clean'
export { default as Svg16PositiveImpact } from '../Icons/16PositiveImpact'
export { default as Svg16SustainablePackaging } from '../Icons/16SustainablePackaging'
export { default as Svg16CrueltyFree } from '../Icons/16CrueltyFree'
export { default as Svg16Add } from '../Icons/16Add'
export { default as Svg16ArrowBack } from '../Icons/16ArrowBack'
export { default as Svg16ArrowDown } from '../Icons/16ArrowDown'
export { default as Svg16ArrowForward } from '../Icons/16ArrowForward'
export { default as Svg16ArrowUp } from '../Icons/16ArrowUp'
export { default as Svg16Available } from '../Icons/16Available'
export { default as Svg16AppStore } from '../Icons/16AppStore'
export { default as Svg16BagCount } from '../Icons/16BagCount'
export { default as Svg16Bag } from '../Icons/16Bag'
export { default as Svg16Bookmark } from '../Icons/16Bookmark'
export { default as Svg16Bookmarks } from '../Icons/16Bookmarks'
export { default as Svg16CaretBack } from '../Icons/16CaretBack'
export { default as Svg16CaretDown } from '../Icons/16CaretDown'
export { default as Svg16CaretForward } from '../Icons/16CaretForward'
export { default as Svg16CaretUp } from '../Icons/16CaretUp'
export { default as Svg16Check } from '../Icons/16Check'
export { default as Svg16Clock } from '../Icons/16Clock'
export { default as Svg16DotActive } from '../Icons/16DotActive'
export { default as Svg16DotInactive } from '../Icons/16DotInactive'
export { default as Svg16Eye } from '../Icons/16Eye' // TODO remove once actual icons are obtained
export { default as Svg16EyeSlashed } from '../Icons/16EyeSlashed' // TODO remove once actual icons are obtained
export { default as Svg16ExclamationCircle } from '../Icons/16ExclamationCircle'
export { default as Svg16ExclamationTriangle } from '../Icons/16ExclamationTriangle'
export { default as Svg16Filters } from '../Icons/16Filters'
export { default as Svg16HeartEmpty } from '../Icons/16HeartEmpty'
export { default as Svg16HeartFilled } from '../Icons/16HeartFilled'
export { default as Svg16InfoCircle } from '../Icons/16InfoCircle'
export { default as Svg16Location } from '../Icons/16Location'
export { default as Svg16LocationPin } from '../Icons/16LocationPin'
export { default as Svg16Menu } from '../Icons/16Menu'
export { default as Svg16Minus } from '../Icons/16Minus'
export { default as Svg16Night } from '../Icons/16Night'
export { default as Svg16NotAvailable } from '../Icons/16NotAvailable'
export { default as Svg16PlayStore } from '../Icons/16PlayStore'
export { default as Svg16Search } from '../Icons/16Search'
export { default as Svg16SearchIcon } from '../Icons/16SearchIcon'
export { default as Svg16Share } from '../Icons/16Share'
export { default as Svg16StarFilled } from '../Icons/16StarFilled'
export { default as Svg16StarHalf } from '../Icons/16StarHalf'
export { default as Svg16StarOutlined } from '../Icons/16StarOutlined'
export { default as Svg16Trending } from '../Icons/16Trending'
export { default as Svg16Tryon } from '../Icons/16Tryon'
export { default as Svg16Video } from '../Icons/16Video'
export { default as Svg16VideoFilled } from '../Icons/16VideoFilled'
export { default as Svg16X } from '../Icons/16X'
export { default as Svg16ZoomIn } from '../Icons/16ZoomIn'
export { default as Svg16ZoomOut } from '../Icons/16ZoomOut'
export { default as Svg24Add } from '../Icons/24Add'
export { default as Svg24ArrowBack } from '../Icons/24ArrowBack'
export { default as Svg24ArrowDown } from '../Icons/24ArrowDown'
export { default as Svg24ArrowForward } from '../Icons/24ArrowForward'
export { default as Svg24ArrowUp } from '../Icons/24ArrowUp'
export { default as Svg24AppStore } from '../Icons/24AppStore'
export { default as Svg24BagCount } from '../Icons/24BagCount'
export { default as Svg24Bag } from '../Icons/24Bag'
export { default as Svg24Bookmark } from '../Icons/24Bookmark'
export { default as Svg24Bookmarks } from '../Icons/24Bookmarks'
export { default as Svg24CaretBack } from '../Icons/24CaretBack'
export { default as Svg24CaretDown } from '../Icons/24CaretDown'
export { default as Svg24CaretForward } from '../Icons/24CaretForward'
export { default as Svg24CaretUp } from '../Icons/24CaretUp'
export { default as Svg24Check } from '../Icons/24Check'
export { default as Svg24Clean } from '../Icons/24Clean'
export { default as Svg24Clock } from '../Icons/24Clock'
export { default as Svg24ConsciousBeauty } from '../Icons/24ConsciousBeauty'
export { default as Svg24CrueltyFree } from '../Icons/24CrueltyFree'
export { default as Svg24Edit } from '../Icons/24Edit'
export { default as Svg24Filters } from '../Icons/24Filters'
export { default as Svg24HeartEmpty } from '../Icons/24HeartEmpty'
export { default as Svg24HeartFilled } from '../Icons/24HeartFilled'
export { default as Svg24InfoCircle } from '../Icons/24InfoCircle'
export { default as Svg24Location } from '../Icons/24Location'
export { default as Svg24LocationPin } from '../Icons/24LocationPin'
export { default as Svg24Menu } from '../Icons/24Menu'
export { default as Svg24Minus } from '../Icons/24Minus'
export { default as Svg24Night } from '../Icons/24Night'
export { default as Svg24PositiveImpact } from '../Icons/24PositiveImpact'
export { default as Svg24PlayStore } from '../Icons/24PlayStore'
export { default as Svg24Search } from '../Icons/24Search'
export { default as Svg24SearchIcon } from '../Icons/24SearchIcon'
export { default as Svg24Share } from '../Icons/24Share'
export { default as Svg24StarFilled } from '../Icons/24StarFilled'
export { default as Svg24StarHalf } from '../Icons/24StarHalf'
export { default as Svg24StarOutlined } from '../Icons/24StarOutlined'
export { default as Svg24SustainablePackaging } from '../Icons/24SustainablePackaging'
export { default as Svg24Trending } from '../Icons/24Trending'
export { default as Svg24Tryon } from '../Icons/24Tryon'
export { default as Svg24Vegan } from '../Icons/24Vegan'
export { default as Svg24Video } from '../Icons/24Video'
export { default as Svg24VideoFilled } from '../Icons/24VideoFilled'
export { default as Svg24X } from '../Icons/24X'
export { default as Svg24ZoomIn } from '../Icons/24ZoomIn'
export { default as Svg24ZoomOut } from '../Icons/24ZoomOut'
export { default as Svg24Facebook } from '../Icons/24Facebook'
export { default as Svg24Instagram } from '../Icons/24Instagram'
export { default as Svg24Pinterest } from '../Icons/24Pinterest'
export { default as Svg24TikTok } from '../Icons/24TikTok'
export { default as Svg24Trash } from '../Icons/24Trash'
export { default as Svg24Twitter } from '../Icons/24Twitter'
export { default as Svg24Youtube } from '../Icons/24Youtube'
export { default as Svg40Facebook } from '../Icons/40Facebook'
export { default as Svg40Pinterest } from '../Icons/40Pinterest'
export { default as Svg40Instagram } from '../Icons/40Instagram'
export { default as Svg40Twitter } from '../Icons/40Twitter'
export { default as Svg40TikTok } from '../Icons/40TikTok'
export { default as Svg40Youtube } from '../Icons/40Youtube'
export { default as Svg24Wallet } from '../Icons/24Wallet'
export { default as Svg24UserCircle } from '../Icons/24UserCircle'
export { default as Svg24EmailOpen } from '../Icons/24EmailOpen'
export { default as Svg24AddressCard } from '../Icons/24AddressCard'
export { default as SvgcustomLargeAppStore } from '../Icons/customLargeAppstore'
export { default as SvgcustomMediumAppStore } from '../Icons/customMediumAppstore'
export { default as SvgcustomLargePlayStore } from '../Icons/customLargePlaystore'
export { default as SvgcustomMediumPlayStore } from '../Icons/customMediumPlaystore'
export { default as AmericanExpress } from '../Icons/AmericanExpress'
export { default as ColorBar } from '../Icons/ColorBar'
export { default as ColorBarThick } from '../Icons/ColorBarThick'
export { default as CreditCardAmexFrontView } from '../Icons/CreditCardAmexFrontView'
export { default as CreditCardBackView } from '../Icons/CreditCardBackView'
export { default as CreditCardDefault } from '../Icons/CreditCardDefault'
export { default as Discover } from '../Icons/Discover'
export { default as MasterCard } from '../Icons/MasterCard'
export { default as UltaLogo } from '../Icons/UltaLogo'
export { default as UltamateRewardsCreditCard } from '../Icons/UltamateRewardsCreditCard'
export { default as UltamateRewardsMasterCard } from '../Icons/UltamateRewardsMasterCard'
export { default as Visa } from '../Icons/Visa'
export { default as Svg24Burst } from '../Icons/24Burst'
export { default as PaypalLogo } from '../Icons/PaypalLogo'
export { default as Phone } from '../Icons/Phone'
export { default as MessageBubble } from '../Icons/MessageBubble'
export { default as Gem } from '../Icons/Gem'
export { default as FastCheckout } from '../Icons/FastCheckout'
export { default as HeartEmpty } from '../Icons/HeartEmpty'
export { default as Loader } from '../Icons/Loader'
export { default as Svg12Gem } from '../Icons/12Gem';
export { default as Svg16Gem } from '../Icons/16Gem';
export { default as Svg24Gem } from '../Icons/24Gem';
export { default as Svg12QuestionCircle } from '../Icons/12QuestionCircle';
export { default as Svg16QuestionCircle } from '../Icons/16QuestionCircle';
export { default as Svg24QuestionCircle } from '../Icons/24QuestionCircle';
export { default as Svg12ShippingBoxClosed } from '../Icons/12ShippingBoxClosed';
export { default as Svg16ShippingBoxClosed } from '../Icons/16ShippingBoxClosed';
export { default as Svg24ShippingBoxClosed } from '../Icons/24ShippingBoxClosed';

export { default as Svg12Print } from '../Icons/12Print'
export { default as Svg16Print } from '../Icons/16Print'
export { default as Svg24Print } from '../Icons/24Print'
export { default as Svg12Copy } from '../Icons/12Copy'
export { default as Svg16Copy } from '../Icons/16Copy'
export { default as Svg24Copy } from '../Icons/24Copy'
export { default as EnvelopeClosed } from '../Icons/EnvelopeClosed'
export { default as Svg12HamBurger } from '../Icons/12HamBurger'
export { default as Svg16HamBurger } from '../Icons/16HamBurger'
export { default as Svg24HamBurger } from '../Icons/24HamBurger'
export { default as Svg12BagIcon } from '../Icons/12BagIcon'
export { default as Svg16BagIcon } from '../Icons/16BagIcon'
export { default as Svg24BagIcon } from '../Icons/24BagIcon'
export { default as Svg16Edit } from '../Icons/16Edit'
export { default as Svg16Trash } from '../Icons/16Trash'
